import React, { useState, useRef } from "react";
import Dropzone from "react-dropzone";
import axios from "axios";

export const AllInOne = () => {
    const [videos, setVideos] = useState([]);
    const [frames, setFrames] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isMerging, setIsMerging] = useState(false);
    const videoRef = useRef(null);

    const handleDrop = (acceptedFiles) => {
        const newFiles = acceptedFiles.filter(
            (file) => !videos.some((existingFile) => existingFile.name === file.name)
        );
        setVideos((prevVideos) => [...prevVideos, ...newFiles]);
    };

    const extractFrames = async () => {
        setLoading(true);
        const formData = new FormData();
        videos.forEach((video) => formData.append("videos", video));

        try {
            const response = await axios.post("http://localhost:5000/extract-frames", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setFrames(response.data.frames);
        } catch (error) {
            console.error("Error extracting frames:", error);
        } finally {
            setLoading(false);
        }
    };

    const mergeVideos = async () => {
        if (videos.length < 2) {
            alert("Please upload at least two videos to merge.");
            return;
        }

        const formData = new FormData();
        videos.forEach((video) => formData.append("videos", video));

        try {
            setIsMerging(true);
            const response = await axios.post("http://localhost:5000/merge-videos", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "merged_video.mp4");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Error merging videos:", error);
        } finally {
            setIsMerging(false);
        }
    };

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <h1>All-in-One Video Editor</h1>
            <Dropzone onDrop={handleDrop} accept="video/*" multiple>
                {({ getRootProps, getInputProps }) => (
                    <div
                        {...getRootProps()}
                        style={{
                            border: "2px dashed #cccccc",
                            padding: "20px",
                            marginBottom: "20px",
                            cursor: "pointer",
                        }}
                    >
                        <input {...getInputProps()} />
                        <p>Drag and drop videos here, or click to select</p>
                        {videos.length > 0 && (
                            <ul>
                                {videos.map((video, index) => (
                                    <li key={index}>{video.name}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                )}
            </Dropzone>

            <button onClick={extractFrames} disabled={loading}>
                {loading ? "Extracting Frames..." : "Extract Frames"}
            </button>
            <button onClick={mergeVideos} disabled={isMerging}>
                {isMerging ? "Merging..." : "Merge Videos"}
            </button>

            {frames.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                    <h2>Extracted Frames</h2>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {frames.map((frame, index) => (
                            <img
                                key={index}
                                src={`http://localhost:5000${frame}`}
                                alt={`Frame ${index}`}
                                style={{
                                    width: "100px",
                                    margin: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
